import { customerFunctions } from 'packs/customers/functions'
import initTooltips from 'src/tooltips'
import onIndexRefresh from 'src/indexRefresh'

export default () => {
  customerFunctions()

  const notesDatatable = $('#myyja-notes-datatable').DataTable({
    language: {
      url: '/datatable_i18n'
    },
    processing: true,
    serverSide: true,
    ajax: {
      url: $('#myyja-notes-datatable').data('source')
    },
    order: [[9, 'asc']],
    columns: [
      { data: 'company_name' },
      { data: 'location_name' },
      { data: 'business_id' },
      { data: 'industry' },
      // TODO.md U-76: `address-col` replaces a `nth-child(5)` CSS selector — see site.scss.
      { data: 'address', className: 'address-col' },
      { data: 'contact_person' },
      { data: 'phone' },
      { data: 'email' },
      {
        data: 'notes',
        className: 'notes-col',
        createdCell: function(td, cellData, rowData) {
          if (rowData.notes_full) {
            td.setAttribute('data-bs-toggle', 'tooltip')
            td.setAttribute('data-bs-placement', 'left')
            td.setAttribute('data-bs-custom-class', 'notes-tooltip')
            td.setAttribute('title', rowData.notes_full)
          }
        }
      },
      { data: 'follow_up_date' }
    ],
    drawCallback: function() {
      // T-98: the dispose-then-create loop this file already had correctly is now shared —
      // `src/tooltips.js`. The QC pack's copy was the one that leaked.
      initTooltips(document.querySelector('#myyja-notes-datatable'))
    }
  })

  // 🚨 **T-108: this table showed STALE data after a save, and had since T-102 shipped.** Each row links to
  // `edit_customer_basic_informations_path` with the remote offcanvas, so saving from the dashboard renders
  // the very template that asks for a refresh — and under the old `window.refreshIndexTable` slot the
  // dashboard got the no-op, because only the four pages *named* "index" had claimed it. Nothing was
  // broken here; the dashboard simply was not on the list, which is the failure mode a global slot has and
  // a delegated event does not.
  onIndexRefresh('myyjaNotes', notesDatatable)
}
